// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hSDE","questions":"styles_questions__2yNHt","footer":"styles_footer__39OCA"};